import { useSelector } from 'react-redux';
import { selectQuestionnaireRoutes } from '../../../routes/slice';
import PreviewGeneralCorporationTrust from './General/preview';
import PreviewNonUsCorpOrPartnership from './NonUSCorpofPartnership/preview';
import PreviewNonUSTrust from './NonUSTrust/preview';
import PreviewUSCorpOrPartnership from './USCorpOrPartnership/preview';
import PreviewUSTrust from './USTrust/preview';

export interface ICorporationTrustPreviewProps {}

export default function CorporationTrustPreview(
  props: ICorporationTrustPreviewProps,
) {
  const routes = useSelector(selectQuestionnaireRoutes).routes;

  return (
    <>
      <h1 className="w-full rounded-t-2xl bg-green text-white px-4 font-semibold mt-6 pl-6 py-4">
        Corporation Trust
      </h1>
      {routes.income.corporationTrust && <PreviewGeneralCorporationTrust />}
      {routes.income.corporationTrust.nonUsCorpOfPartnership && (
        <PreviewNonUsCorpOrPartnership />
      )}
      {routes.income.corporationTrust.nonUsTrust && <PreviewNonUSTrust />}
      {routes.income.corporationTrust.usCorpOrPartnership && (
        <PreviewUSCorpOrPartnership />
      )}
      {routes.income.corporationTrust.usTrust && <PreviewUSTrust />}
    </>
  );
}
